import React, { useState, useEffect } from "react";

export default function Wysiwyg({ children, name, placeholder, className, value, id, onChange }) {
    const [Quill, setQuill] = useState(null);

    useEffect(() => {
        // Dynamically import ReactQuill only if it's running in the browser
        if (typeof window !== "undefined") {
            import("react-quill").then((module) => {
                setQuill(() => module.default); // Load ReactQuill
            });
        }
    }, []);

    // Render a fallback or nothing until ReactQuill is loaded
    if (!Quill) {
        return <div>Loading editor...</div>;
    }

    return (
        <Quill
            theme="snow"
            style={{
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                color: "white",
                minHeight: "200px",
            }}
            name={name}
            placeholder={placeholder}
            className={className}
            id={id}
            value={children}
            onChange={onChange}
        />
    );
}
